module.exports = __webpack_public_path__ + "img/48.4c6fbc81.png";